import React, { useEffect } from 'react';
import s from './Notification.module.css';

const Notification = () => {
    return <div>notification</div>;
};

export default Notification;
